import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { AspectRatio } from 'components/AspectRatio'

export const SEmailModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  & > form {
    width: 100%;
  }
  & > form > fieldset {
    margin-bottom: 0.75rem;
  }
`

export const STitle = styled(Text)`
  margin-bottom: 1.5rem;
  color: black;
  font-weight: bold;
  font-size: 1.25rem;
`

export const SText = styled(Text)`
  margin-bottom: 1.5rem;
`

export const SAspectRatio = styled(AspectRatio)`
  & > div,
  img,
  video {
    width: 100%;
    object-fit: cover;
  }
  margin: 1.5rem 0;
  width: 14rem;
`
export const SButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 1.5rem;

  margin-bottom: 1.5rem;

  & > button {
    flex: 1;

    &:first-of-type {
      margin-right: 1.5rem;
    }
  }
`

export const SPreviewContainer = styled.div`
  display: flex;
  margin: 1.5rem 0;
  width: 14rem;
  height: 14rem;
  box-shadow: var(--card-shadow);
  & img,
  video,
  > div {
    width: 100%;
    object-fit: cover;
  }
`
